// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","caption2":"_3FCgXshmQfWC83mTTDn6Lf","borderGrey2":"#e2e2e2","customWhite":"#ffffff","textGrey":"#3f3f3f","customBlack":"#000000","container":"_18P-o6whP9Wyi2XQeRbhad _3FCgXshmQfWC83mTTDn6Lf","available":"_1tIpNllvQTtuprNKov7_bU","none":"_1A_NmJlbpwmbGUklB4P8qV","dark":"_3skI5ARX7CNQpdgUkGgYJS"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/stock-label/StockLabel.css
// module id = 1017
// module chunks = 1